import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/notifications')({
  beforeLoad: () => {
    throw redirect({ to: '/app/conversations', replace: true });
  },
});
